var TWOFOLD_TRANSFER_BTN_HTML = "<button type=\"submit\" name=\"transfer_items\" class=\"button--primary button--full button--large\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>";

function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "allow_zero_value_cart": false,
    "transfer_label":"Transfer Cart",
    "custom_style":"body.punchout button[name=\"checkout\"], body.punchout .shopify-payment-button { display: none !important; }",
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html": TWOFOLD_TRANSFER_BTN_HTML,
    "return_selector": "header",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>",
    "graphql_token": "e30d5e0b8c85eca07d441d6d1c007ff8",
  };

    POExt = new Po2go_Shopify(store_config);
    POSession = new Po2go({
        'account':'ea420cb9-02ae-466d-9ad0-63960100e25b',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config

    twofoldInitTransferButtonKeeper();
}

function twofoldInPunchout(){
  return document.body.classList.contains('punchout');
}

function twofoldEnsureTransferButtons(){
  if (!twofoldInPunchout()) return;

  document.querySelectorAll('button[name="checkout"]').forEach(function(checkoutBtn){
    var parent = checkoutBtn.parentElement;
    if (!parent || parent.querySelector('button[name="transfer_items"]')) return;
    parent.insertAdjacentHTML('beforeend', TWOFOLD_TRANSFER_BTN_HTML);
  });
}

function twofoldInitTransferButtonKeeper(){
  twofoldEnsureTransferButtons();

  var twofoldScheduled = false;
  var twofoldObserver = new MutationObserver(function(){
    if (twofoldScheduled) return;
    twofoldScheduled = true;
    requestAnimationFrame(function(){
      twofoldScheduled = false;
      twofoldEnsureTransferButtons();
    });
  });
  twofoldObserver.observe(document.body, { childList: true, subtree: true });
}